import { Box } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import { useLocation } from "react-router-dom"
import { CSSTransition } from "react-transition-group"
import {
  PromoCard,
  useGetEventCashiers,
} from "../../../app/data/promotion/promotionApi"
import ErrorNotification from "../ErrorNotification"
import Loading from "../Loading"
import SearchEmployeesInput from "../SearchEmployeesInput"
import CashiersCardDetails from "./CashiersCardDetails"
import { cardsCont, container, searchCont } from "./style"

export default function CashiersDetails() {
  const [query, setQuery] = useState("")
  const [animateOnLoad, setAnimateOnLoad] = useState(false)
  const nodeRef = useRef<HTMLDivElement | null>(null)
  const { state }: { state: PromoCard } = useLocation()
  const { data, isLoading, isError } = useGetEventCashiers(state.id)

  useEffect(() => {
    setAnimateOnLoad(true)
  }, [])

  if (isError && !isLoading) {
    return <ErrorNotification />
  }

  if ((isLoading || !data) && !isError) {
    return <Loading />
  }

  return (
    <Box sx={container}>
      <Box sx={searchCont}>
        <SearchEmployeesInput query={query} setQuery={setQuery} />
      </Box>

      <CSSTransition
        timeout={300}
        in={animateOnLoad}
        nodeRef={nodeRef}
        classNames="appearance"
        mountOnEnter
        unmountOnExit
      >
        <Box ref={nodeRef} sx={cardsCont}>
          {data &&
            data.length > 0 &&
            data.map((card) => (
              <CashiersCardDetails
                key={card.cashier_id}
                cashier={card}
                event={state}
              />
            ))}
        </Box>
      </CSSTransition>
    </Box>
  )
}
